var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGnbMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5698 18.09H19.253C18.8763 16.8364 17.7245 15.915 16.3499 15.915C14.9753 15.915 13.8243 16.8364 13.4468 18.09H2.43003C1.9498 18.09 1.56006 18.4798 1.56006 18.96C1.56006 19.4403 1.9498 19.83 2.43003 19.83H13.4467C13.8234 21.0836 14.9753 22.005 16.3499 22.005C17.7244 22.005 18.8755 21.0836 19.253 19.83H21.5698C22.0509 19.83 22.4398 19.4403 22.4398 18.96C22.4398 18.4798 22.0509 18.09 21.5698 18.09ZM16.3499 20.265C15.6304 20.265 15.0449 19.6795 15.0449 18.96C15.0449 18.2405 15.6304 17.655 16.3499 17.655C17.0694 17.655 17.6549 18.2405 17.6549 18.96C17.6549 19.6795 17.0694 20.265 16.3499 20.265Z",
    fill: "#046C9C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5698 4.17008H19.253C18.8755 2.91644 17.7245 1.99512 16.3499 1.99512C14.9753 1.99512 13.8243 2.91644 13.4467 4.17008H2.43003C1.9498 4.17008 1.56006 4.55982 1.56006 5.04005C1.56006 5.52029 1.9498 5.91003 2.43003 5.91003H13.4467C13.8243 7.16371 14.9753 8.08503 16.3499 8.08503C17.7245 8.08503 18.8755 7.16371 19.253 5.91007H21.5698C22.0509 5.91007 22.4398 5.52033 22.4398 5.04009C22.4398 4.55986 22.0509 4.17008 21.5698 4.17008ZM16.3499 6.34504C15.6304 6.34504 15.0449 5.75955 15.0449 5.04005C15.0449 4.32056 15.6304 3.73507 16.3499 3.73507C17.0694 3.73507 17.6549 4.32056 17.6549 5.04005C17.6549 5.75955 17.0694 6.34504 16.3499 6.34504Z",
    fill: "#046C9C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.5698 11.13H10.5532C10.1756 9.8764 9.02457 8.95508 7.65001 8.95508C6.27546 8.95508 5.12442 9.8764 4.74687 11.13H2.43003C1.9498 11.13 1.56006 11.5198 1.56006 12C1.56006 12.4802 1.9498 12.87 2.43003 12.87H4.74683C5.12442 14.1236 6.27542 15.045 7.64997 15.045C9.02453 15.045 10.1756 14.1236 10.5531 12.87H21.5698C22.0509 12.87 22.4398 12.4802 22.4398 12C22.4398 11.5198 22.0509 11.13 21.5698 11.13ZM7.64997 13.305C6.93048 13.305 6.34499 12.7195 6.34499 12C6.34499 11.2805 6.93048 10.695 7.64997 10.695C8.36947 10.695 8.95496 11.2805 8.95496 12C8.95496 12.7195 8.36947 13.305 7.64997 13.305Z",
    fill: "#046C9C"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGnbMypage);
export default __webpack_public_path__ + "static/media/icon-gnb-mypage.be20eea0e6a4efaf7a19746becb7e11c.svg";
export { ForwardRef as ReactComponent };